import { render } from "./Who.vue?vue&type=template&id=451a1d20"
import script from "./Who.vue?vue&type=script&lang=js"
export * from "./Who.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__